<template>
  <div>
    <criterion-category-index
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :title="$t('menu.program_criterion_category_list')"
      :serviceName="serviceName"
    />
  </div>
</template>

<script>
import CriterionCategoryIndex from "./CriterionCategoryIndex";

export default {
  name: "Index",
  data() {
    return {
      serviceName: "criterion-categories",
      formSearch: [
        {
          label: this.$t("program_criterion_category.name"),
          name: "name__~",
          value: "",
          type: "input"
        }
      ],
      columns: {
        id: this.$t("program_criterion_category.id"),
        name: this.$t("program_criterion_category.name"),
        description: this.$t("program_criterion_category.description"),
        created_at: this.$t("program_criterion_category.created_at"),
        updated_at: this.$t("program_criterion_category.updated_at")
      }
    };
  },
  components: { CriterionCategoryIndex },
  methods: {},
  mounted() {}
};
</script>
